import { render, staticRenderFns } from "./ComponentPlantCompanyStatic.vue?vue&type=template&id=46ecb685&scoped=true&"
import script from "./ComponentPlantCompanyStatic.vue?vue&type=script&lang=js&"
export * from "./ComponentPlantCompanyStatic.vue?vue&type=script&lang=js&"
import style0 from "./ComponentPlantCompanyStatic.vue?vue&type=style&index=0&id=46ecb685&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ecb685",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VContainer,VFlex,VLayout,VProgressCircular})
